import { Injectable } from '@angular/core';
import { ApiService, UtilService, PagedSearch, PagedResult } from '../../../shared/index';
import { IEventCustomRegFieldService } from './ievent-custom-reg-field.service';
import { EventCustomRegField } from './event-custom-reg-field.model';

@Injectable()
export class EventCustomRegFieldService implements IEventCustomRegFieldService {
  public _apiService: ApiService;
  public _utilService: UtilService;

  public constructor(apiService: ApiService, utilService: UtilService) {
    this._apiService = apiService;
    this._utilService = utilService;
  }

  public getEventCustomRegFields = (eventId: number, forceRefresh?: boolean): Promise<PagedResult> => {
    let url: string = 'Event/' + eventId.toString() + '/CustomFields?PageSize=0&PageNumber=0&OrderBy=DisplayOrder:Asc,Id:Asc';
    if (forceRefresh) return this._apiService.get(url, this._apiService.getDefaultApiCacheOptionsForNoCache());
    return this._apiService.get(url);
  };

  public getEventCustomRegField = (eventRegFieldId: number): Promise<EventCustomRegField> => {
    let url: string = 'EventItemCustomField/' + eventRegFieldId.toString();
    return this._apiService.get(url);
  };

  public upsertEventCustomRegField = (eventCustomRegField: EventCustomRegField): Promise<number> => {
    let url: string = '';
    url = 'Event/' + eventCustomRegField.EventId.toString() + '/CustomFields';
    if (eventCustomRegField.Id > 0) return this._apiService.put(url, eventCustomRegField);
    else return this._apiService.post(url, eventCustomRegField);
  };

  public deleteEventCustomRegField = (eventCustomRegFieldId: number): Promise<void> => {
    let url: string = '';

    url = 'EventItemCustomField/' + eventCustomRegFieldId.toString();
    return this._apiService.delete(url).then(
      (): Promise<void> => {
        return Promise.resolve();
      }
    );
  };

  /**
   * call api to set new order of event custom fields
   * @param eventId
   * @param orderedEventCustomFieldIds
   */
  public reorderCustomFields(eventId: number, orderedEventCustomFieldIds: Array<number>): Promise<any> {
    let url: string = '/Event/' + eventId + '/OrderCustomFields';
    return this._apiService.post(url, orderedEventCustomFieldIds);
  }
}
